import styled from 'styled-components';

import { GetDeliveriesQuery } from 'data/__generated__';

import { DynamicDeliveryTag } from 'components/DynamicDeliveryTag';

import { colors } from 'constants/colors';
import { DELIVERY_STATES_LABELS, getColorsFromState } from '../constants/states';

type DeliveryCalendarEventProps = {
    delivery: GetDeliveriesQuery['deliveries'][number];
    isSelected: boolean;
};

export const DeliveryCalendarEvent = ({ delivery, isSelected }: DeliveryCalendarEventProps) => {
    const { state, organizationName, siteName, roundName, roundColor, label, isDynamic } = delivery;
    const { backgroundColor, labelColor } = getColorsFromState(state);

    return (
        <EventContainer $backgroundColor={backgroundColor} $labelColor={labelColor} $isSelected={isSelected}>
            <RoundStripe $color={roundColor || colors.pantinGrey} />
            <EventBody>
                <EventTitleRow>
                    <EventTitle>{organizationName || siteName}</EventTitle>
                    <DynamicDeliveryTag isDynamic={isDynamic} label="Livraison dynamique" size={12} />
                </EventTitleRow>
                <EventDetails>
                    {roundName ? <span>{roundName}</span> : null}
                    {label ? <span>{label}</span> : null}
                    <EventState>{DELIVERY_STATES_LABELS[state]}</EventState>
                </EventDetails>
            </EventBody>
        </EventContainer>
    );
};

const EventContainer = styled.div<{
    $backgroundColor: string;
    $labelColor: string;
    $isSelected: boolean;
}>`
    display: flex;
    align-items: stretch;
    padding: 2px 4px;
    border-radius: 3px;
    font-size: 11px;
    line-height: 1.3;
    background-color: ${({ $backgroundColor }) => $backgroundColor};
    color: ${({ $labelColor }) => $labelColor};
    opacity: ${({ $isSelected }) => ($isSelected ? 1 : 0.7)};
    outline: ${({ $isSelected }) => ($isSelected ? '3px solid #000' : 'none')};
    outline-offset: -1px;
    box-shadow: ${({ $isSelected }) =>
        $isSelected ? '0 0 0 2px white, 0 0 0 5px #000, 0 4px 12px rgba(0,0,0,0.3)' : 'none'};
    transform: ${({ $isSelected }) => ($isSelected ? 'scale(1.04)' : 'none')};
    z-index: ${({ $isSelected }) => ($isSelected ? 10 : 'auto')};
    cursor: pointer;
    overflow: hidden;
    transition: all 0.15s ease;

    &:hover {
        opacity: 1;
    }
`;

const RoundStripe = styled.div<{ $color: string }>`
    width: 3px;
    background-color: ${({ $color }) => $color};
    margin-right: 4px;
    border-radius: 2px;
    flex-shrink: 0;
`;

const EventBody = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
`;

const EventTitleRow = styled.div`
    display: flex;
    align-items: center;
    gap: 3px;
    min-width: 0;
`;

const EventTitle = styled.div`
    flex: 1;
    min-width: 0;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const EventDetails = styled.div`
    display: flex;
    gap: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const EventState = styled.span`
    font-style: italic;
`;
